export default __webpack_public_path__ + "static/media/404.5f0f70d8.svg";